import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Moon, ArrowRight, Footprints } from "lucide-react";
import { api } from "@/lib/apiClient";
import { markFromCoach } from "@/components/BackToCoach";

const localDate = () => new Date().toLocaleDateString("en-CA");
const KIND = { reset: "Reset", immersion: "Immersion", installation: "Installation" };

// "Before you sleep": tonight's audio and tomorrow's action, set by his coach at the end of a talk. Pinned until done.
export function BeforeYouSleepCard({ plan, compact = false }) {
  const navigate = useNavigate();
  if (!plan) return null;
  const a = plan.audio;
  const go = () => { markFromCoach(a.kind); navigate(a.route); };
  return (
    <motion.section initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
      className={`w-full text-left rounded-3xl border border-primary/35 bg-gradient-to-br from-primary/[0.14] via-card/60 to-card/40 p-5 sm:p-6 ${compact ? "" : "mb-8"}`} data-testid="before-you-sleep">
      <p className="text-[10px] uppercase tracking-[0.22em] text-primary flex items-center gap-2"><Moon className="w-3.5 h-3.5" /> Before you sleep · set by {plan.coach}</p>
      <p className="font-serif text-2xl leading-tight mt-3" data-testid="before-you-sleep-title">{a.title}</p>
      <p className="text-xs text-muted-foreground mt-1">{KIND[a.kind]}{plan.why ? ` · ${plan.why}` : ""}</p>
      <button onClick={go} data-testid="before-you-sleep-go"
        className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground py-3 text-sm font-medium hover:opacity-90 transition-opacity">
        Start {a.title} now <ArrowRight className="w-4 h-4" />
      </button>
      <div className="mt-4 pt-4 border-t border-white/10 flex items-start gap-3">
        <Footprints className="w-4 h-4 text-primary mt-0.5 shrink-0" />
        <p className="text-sm"><span className="text-muted-foreground">Tomorrow: </span><span data-testid="before-you-sleep-action">{plan.action}</span></p>
      </div>
    </motion.section>
  );
}

export default function BeforeYouSleep() {
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    const load = () => api.get("/routine/tonight", { params: { local_date: localDate() } }).then((r) => setPlan(r.data.plan)).catch(() => {});
    load(); window.addEventListener("xc-tonight-refresh", load);
    return () => window.removeEventListener("xc-tonight-refresh", load);
  }, []);
  return <BeforeYouSleepCard plan={plan} />;
}
